import { useCallback, useState } from "react";
import Button from "../../input/button";
import useAdminAPIClient from "../../../api/admin/hooks/useAdminAPIClient";
import { TextField } from "@mui/material";

const GlobalMessaging = () => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const { sendGlobalMessage } = useAdminAPIClient();

  const onSubmit = useCallback(async () => {
    setSaving(true);
    await sendGlobalMessage({ subject, message });
    setMessage("");
    setSubject("");
    setSaving(false);
  }, [message, subject, sendGlobalMessage]);

  return (
    <div className="global-messaging">
      <TextField
        className="messaging_input"
        label="Subject"
        value={subject}
        onChange={(e) => setSubject(e.target.value)}
      />
      <textarea
        className="messaging_input-area scroller"
        placeholder="Message to broadcast to all users"
        maxLength={500}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />
      <Button
        text="Send Message"
        disabled={message.trim().length === 0}
        loading={saving}
        onClick={onSubmit}
      />
    </div>
  );
};

export default GlobalMessaging;
